import styled from "styled-components";

const GameOverDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  background: rgba(242, 205, 206, 0.9);
  font-size: 20px;
`;

export default ({children}: any) => {
    return (
      <GameOverDiv>
          {children}
      </GameOverDiv>
    );
  };  